import * as yup from 'yup';
import { CountryUtils } from './CountryUtils';
import { RegexUtils } from './RegexUtils';

const globalNameRegExp = RegexUtils.getUserNameRegex();

const email = yup
  .string()
  .email()
  .required();

const password = yup
  .string()
  .min(8)
  .required();

const phoneNumber = yup
  .string()
  .required()
  .matches(
    /^[0-9()\-+ ]{8,16}$/,
    'Accepts minimum 8 maximum 20 characters with at least 8 digits.',
  );

const firstName = yup
  .string()
  .required()
  .matches(globalNameRegExp, 'Only alphabets are allowed for this field');

const lastName = yup
  .string()
  .test('matches', '', val => {
    return val.length > 0 ? globalNameRegExp.test(val) : true;
  })
  .test('', '', val => {
    const country = window.location.pathname.split('/')[1];
    const isHungary = country === CountryUtils.COUNTRY.HUNGARY;
    const isJapan = country === CountryUtils.COUNTRY.JAPAN;
    return isHungary || isJapan ? val.length > 0 : true;
  });

export const ForgotPasswordSchema = yup.object().shape({
  email,
});
export const ResetPasswordSchema = yup.object().shape({
  password,
});

export const LoginSchema = yup.object().shape({
  password: yup.string().required(),
  email,
});

export const RegistrationSchema = yup.object().shape({
  lastName,
  firstName,
  email,
  phoneNumber,
  password,
});

export const CompleteRegistrationSchema = yup.object().shape({
  firstName,
  lastName,
  phoneNumber,
});
